import { render, staticRenderFns } from "./LoanPaymentSchedule.vue?vue&type=template&id=2728bfa8"
import script from "./LoanPaymentSchedule.vue?vue&type=script&lang=js"
export * from "./LoanPaymentSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports